import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';
import { isNative } from './platform';

/**
 * Fire-and-forget haptic feedback, no-op on web. Failures are swallowed —
 * haptics are garnish, never worth surfacing an error for.
 */

export const hapticSelection = (): void => {
  if (!isNative()) return;
  Haptics.impact({ style: ImpactStyle.Light }).catch(() => {});
};

export const hapticSuccess = (): void => {
  if (!isNative()) return;
  Haptics.notification({ type: NotificationType.Success }).catch(() => {});
};

/** Weightier than a selection tick — destructive confirms and credit-spending generate actions. */
export const hapticImpact = (): void => {
  if (!isNative()) return;
  Haptics.impact({ style: ImpactStyle.Medium }).catch(() => {});
};

/** The action was refused (a limit, a validation failure, a blocked delete). */
export const hapticError = (): void => {
  if (!isNative()) return;
  Haptics.notification({ type: NotificationType.Error }).catch(() => {});
};
